/**
 * X (Twitter) icon as an SVG component from the Font Awesome v7.1.0 free collection.
 * @param {object} props - The properties for the SVG element.
 * @param {string} [props.color=white] - The color of the icon. Defaults to "white".
 * @param {number|string} [props.size=16] - The size of the icon (width and height). Defaults to 16.
 * @returns {import("react").ReactElement} The SVG icon component.
 */
export default function XTwitterIcon(props) {
  const { color = "white", size = 16, ...rest } = props;
  // !Font Awesome Free v7.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 640"
      width={size}
      height={size}
      fill={color}
      {...rest}
    >
      <path d="M453.2 112L523.8 112L369.6 288.2L551 528L409 528L297.7 382.6L170.5 528L99.8 528L264.7 339.5L90.8 112L236.4 112L336.9 244.9L453.2 112zM428.4 485.8L467.5 485.8L215.1 152L173.1 152L428.4 485.8z" />
    </svg>
  );
}
